export default __webpack_public_path__ + "static/media/4.20a699a8.jpg";